export default __webpack_public_path__ + "static/media/hand-scis-wht.107b3c43.svg";